import React, { useState, useEffect } from 'react';
import './styles/index.css';

// Components
import ParticleCanvas from './components/ParticleCanvas/ParticleCanvas';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Education from './components/Education/Education';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects';
import Certificates from './components/Certificates/Certificates';
import Footer from './components/Footer/Footer';

// Modals
import ContactModal from './components/Modals/ContactModal';
import ProjectModal from './components/Modals/ProjectModal';
import PrivacyModal from './components/Modals/PrivacyModal';

// Admin
import AdminPanel from './admin_panel_page';

// Hooks
import { useScrollSpy } from './hooks/useScrollSpy';
import { useTypingEffect } from './hooks/useTypingEffect';
import { useFirebaseContent } from './hooks/useFirebaseContent';

// Data
import defaultContent from './data/defaultContent';

function App() { 
  const [content, setContent] = useState(defaultContent);
  const [darkMode, setDarkMode] = useState(() => {
    try {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme === 'light') return false;
      if (savedTheme === 'dark') return true;
      return savedTheme !== null ? JSON.parse(savedTheme) : true;
    } catch (error) {
      return true;
    }
  });

  const [selectedProject, setSelectedProject] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Custom Hooks
  useFirebaseContent(setContent);
  
  const sections = ['home', 'education-skills', 'experience', 'projects', 'certificates', 'contact'];
  const { activeSection, isScrolled } = useScrollSpy(sections);
  
  const typedText = useTypingEffect(content?.headerTitle, 100);

  // Dark Mode side effect
  useEffect(() => {
    localStorage.setItem('theme', JSON.stringify(darkMode));
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <div className="modern-app">
      <ParticleCanvas darkMode={darkMode} />
      
      <Navbar 
        isScrolled={isScrolled} 
        activeSection={activeSection} 
        menuOpen={menuOpen} 
        setMenuOpen={setMenuOpen} 
        darkMode={darkMode} 
        setDarkMode={setDarkMode} 
        t={content} 
      />

      <Hero t={content} typedText={typedText} />
      <Education t={content} />
      <Experience t={content} />
      <Projects t={content} onSelectProject={setSelectedProject} />
      <Certificates t={content} />
      <Footer 
        t={content} 
        onShowContactModal={() => setShowContactModal(true)} 
        onShowPrivacyModal={() => setShowPrivacyModal(true)} 
      />

      <AdminPanel 
        content={content} 
        setContent={setContent} 
        defaultContent={defaultContent} 
        darkMode={darkMode} 
      />

      {selectedProject && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}

      {showContactModal && (
        <ContactModal 
          t={content} 
          onClose={() => setShowContactModal(false)} 
        />
      )}
      
      {showPrivacyModal && (
        <PrivacyModal 
          t={content} 
          onClose={() => setShowPrivacyModal(false)} 
        />
      )}
    </div>
  );
}

export default App;